import React, { useEffect, useState } from "react";
import { inject, observer } from "mobx-react";


import SheetsUpdater from "./helpers/SheetsUpdater";
import Progress from "../Progress";

const SheetsTaskAction = ({
  packId,
  sheets,
  onComplete,
  //
  url,
  body,
  headers,
  baseChatModel,
  models,
  modelVariants,
  useMatchingTokenModel,
  //
  assistantStore,
  chatHelpersStore,
  component,
}) => {

  const [existingSheets, setExistingSheets] = useState([]);
  const [sheetsCreated, setSheetsCreated] = useState([]);
  const [progress, setProgress] = useState({ label: "Creating sheets" });

  const handleComplete = async (...params) => {
    typeof onComplete === "function" && (await onComplete(...params));
  };

  const handleCancelSheetNamesUpdater = async () => {
    try {
      await handleComplete([...sheetsCreated]);
    } catch (e) {
      console.log(`e->`, e);
    }
  };

  const handleSubmitSheetNamesUpdater = async (sheetsWithNewName) => {
    try {
      const _sheetsCreated = [];

      const namesMap = {};

      for (const sheet of sheetsWithNewName) {
        const { newSheetName, sheetName, singularNameOfSheet, fields } = sheet;
        // create sheet (with new name) with basic fields
        const payload = {
          sheetName: newSheetName,
          singularNameOfSheet,
          suggestedSheetName: sheetName,
          fields,
          pack_id: packId,
        };
        const { list } = await chatHelpersStore.createSheetApiHelper(payload);

        namesMap[sheetName] = newSheetName;

        _sheetsCreated.push({
          ...list,
          ...payload,
        });
      }

      setSheetsCreated((pValue) => [...pValue, ..._sheetsCreated]);

      setExistingSheets([]);

      await handleComplete([...sheetsCreated, ..._sheetsCreated], namesMap);
    } catch (e) {
      console.log(`e->`, e);
    }
  };

  const handleOnLoad = async () => {
    try {

      // load all sheets
      await assistantStore.fetchAndLoadSheets();

      const existingSheets = [];
      const sheetsCreated = [];

      for (const sheet of sheets) {
        const { sheetName, singularNameOfSheet, fields } = sheet;

        //if the sheet exists, then add it to the array
        const existingSheet = assistantStore.getSheetByName(sheetName);
        if (existingSheet) {
          existingSheets.push(sheet);
          continue;
        }

        // create sheet with basic fields

        const payload = {
          sheetName,
          singularNameOfSheet,
          fields,
          pack_id: packId,
        };

        const { list } = await chatHelpersStore.createSheetApiHelper(payload);

        sheetsCreated.push({ ...list, ...payload });
      }

      setSheetsCreated(sheetsCreated);
      // handle existing sheets name update before creating subsheet
      if (existingSheets.length) {
        setExistingSheets(existingSheets);
        return;
      }

      await handleComplete(sheetsCreated);
    } catch (e) {
      console.log(`e->`, e);
    }
  };

  const renderSheetsTaskAction = () => {
    if (existingSheets.length) {
      return (
        <SheetsUpdater
          url={url}
          body={body}
          headers={headers}
          baseChatModel={baseChatModel}
          models={models}
          modelVariants={modelVariants}
          useMatchingTokenModel={useMatchingTokenModel}
          params={existingSheets}
          onCancel={handleCancelSheetNamesUpdater}
          onSubmit={handleSubmitSheetNamesUpdater}
          onFetchChatsAccessToken={assistantStore.getChatsAccessToken}
          parentComponent={component}
        />
      );
    }

    return (
      <Progress progress={progress} parentComponent={component}/>
    );
  };

  useEffect(() => {
    handleOnLoad();
  }, []);

  return renderSheetsTaskAction();
};

export default inject(({ store }) => {
  return {
    assistantStore: store.assistantStore,
    chatHelpersStore: store.chatHelpersStore,
  };
})(observer(SheetsTaskAction));
